import React from 'react';

import { Swiper, SwiperSlide } from 'framework7-react';
import PropTypes from 'prop-types';
import { gaPageView } from '../../helpers/Analytics';
import withDocumentCommonUI from '../../helpers/withDocumentCommonUI';

class ViewerContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      zoomed: -1,
      currentPage: 0
    };
  }

  componentDidMount() {
    gaPageView('Viewer');

    let thiss = this;

    if (this.photoGallery) {
      this.props.onSetupGallery(this.photoGallery);
      this.photoGallery.swiper.on('slideChange', () => {
        if (thiss.photoGallery) {
          thiss.setState({
            currentPage: thiss.photoGallery.swiper.activeIndex,
            zoomed: -1
          });
        }
      });

      this.photoGallery.swiper.on('reachEnd', () => {
        if (thiss.photoGallery) {
          thiss.props.onDocumentIsScrolledTillEnd();
        }
      });

      this.photoGallery.swiper.on('imagesReady', () => {
        this.setState({
          scale: 1
        });
      });

      // noinspection JSUnusedLocalSymbols
      this.photoGallery.swiper.on('zoomChange', (scale, imageEl, slideEl) => {
        const slideIndex = /index-\d+/g
          .exec(slideEl.className)[0]
          .replace('index-', '');

        if (this.state.zoomed !== slideIndex) {
          thiss.setState({
            scale: scale,
            zoomed: scale > 1.1 ? parseInt(slideIndex) : -1
          });
        }

        //console.log(slideIndex + ": " + scale);

        if (this.$f7.device.ios) {
          clearTimeout(this.lastZoomTimer);
          this.lastZoomTimer = setTimeout(
            function() {
              imageEl.style.transitionDuration = '0ms';
              imageEl.style.transform = imageEl.style.transform
                .replace('translate3d', 'translate')
                .replace(', 0px', '');
            },
            200,
            imageEl
          );
        }
      });
    }
  }

  render() {
    const { document } = this.props;

    const { zoomed } = this.state;

    return (
      <Swiper
        id="viewer"
        ref={el => {
          this.photoGallery = el;
        }}
        style={{
          height: document.rejected ? 'calc(100% - 100px)' : '100%',
          margin: '0 auto'
        }}
        params={{
          zoom: { maxRatio: 3 },
          direction: 'vertical',
          slidesPerView: 'auto',
          freeMode: true,
          mousewheel: true
        }}
      >
        {document.attachment.map((url, pageNumber) => (
          <SwiperSlide
            zoom={true}
            key={pageNumber}
            className={
              'index-' + pageNumber + (zoomed === pageNumber ? ' zoomed' : '')
            }
          >
            <img
              alt={`Page ${pageNumber + 1}`}
              src={url}
              style={{ height: '80vh' }}
            />
            <label className={'slideIndex'}>{pageNumber + 1}</label>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }
}

ViewerContent.propTypes = {
  document: PropTypes.object,
  onSetupGallery: PropTypes.func,
  onDocumentIsScrolledTillEnd: PropTypes.func
};

export default withDocumentCommonUI(ViewerContent);
